import { useApiQuery } from './useApiQuery';
import { useApiMutation } from './useApiMutation';
import { commentsApi } from '../lib/api/comments';
import type {
  IssueComment,
  CreateCommentRequest,
  UpdateCommentRequest,
} from '@overlayqa/shared';

export function useIssueComments(issueId: string) {
  return useApiQuery<IssueComment[]>({
    queryKey: ['issue-comments', issueId],
    queryFn: (token) => commentsApi.list(token, issueId),
    enabled: !!issueId,
  });
}

export function useCreateComment(issueId: string) {
  return useApiMutation<IssueComment, CreateCommentRequest & { idempotencyKey?: string }>({
    mutationFn: (token, { idempotencyKey, ...body }) =>
      commentsApi.create(token, issueId, body, { idempotencyKey }),
    invalidateKeys: [['issue-comments', issueId]],
  });
}

interface UpdateCommentVariables {
  commentId: string;
  body: UpdateCommentRequest;
}

export function useUpdateComment(issueId: string) {
  return useApiMutation<IssueComment, UpdateCommentVariables>({
    mutationFn: (token, { commentId, body }) =>
      commentsApi.update(token, issueId, commentId, body),
    invalidateKeys: [['issue-comments', issueId]],
  });
}

export function useDeleteComment(issueId: string) {
  return useApiMutation<void, string>({
    mutationFn: (token, commentId) =>
      commentsApi.delete(token, issueId, commentId),
    invalidateKeys: [['issue-comments', issueId]],
  });
}
